import { FolderTree } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { sandboxFilesystemWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  sandboxFilesystemWeb,
  {
    FilesystemTab: () => import('./FilesystemTab'),
    FilesystemPreviewPage: () =>
      import('./FilesystemPreviewPage').then((m) => ({ default: m.FilesystemPreviewPage })),
    FilesystemTabPreview: () =>
      import('./FilesystemTabPreview').then((m) => ({ default: m.FilesystemTabPreview })),
    FilePathScanner: () =>
      import('./components/FilePathScanner').then((m) => ({ default: m.FilePathScanner })),
  },
  {
    icons: { FolderTree },
  },
);
